module.exports = __webpack_public_path__ + "static/assets/GlacialIndifference-Bold.8089134b.woff";